const range = (start, stop, step, value) =>
	Array.from({ length: (stop - start) / step + 1 }, (_, i) => [
		start + i * step,
		value,
	]);

const sidebars = [
	{
		id: 1,
		label: "Integrations",
		type: "endpoint",
		endpointId: 1,
		icon: "fa fa-link",
		children: [],
		config: {
			adminOnly: false,
			readOnly: false,
			viewType: "EndpointList",
			formComponent: "IntegrationForm",
			displayProp: {
				field: "name",
				label: "Name",
				type: "string",
			},
			itemsPerPage: 20,
			preDisplayProperties: [
				// Use this to add columns before the main 'displayProp'
				{
					field: "mapping",
					label: "Mapping",
					type: "componentLink",
					columnClass: "col-1 text-center",
					componentLinkPath: "mapping",
					componentLinkText: "",
					componentLinkIcon: "fa-list",
					componentName: "IntegrationMappingForm",
				},
			],
			displayProperties: [
				{
					field: "description",
					label: "Description",
					type: "string",
				},
			],
			displayColumn: [],
		},
	},
	{
		id: 3,
		label: "Schedules",
		type: "endpoint",
		endpointId: 2,
		icon: "fa fa-calendar",
		children: [],
		config: {
			adminOnly: false,
			readOnly: false,
			editOnly: true,
			viewType: "EndpointList",
			formComponent: "EndpointForm",
			displayProp: {
				field: "name",
				label: "Name",
				type: "string",
			},
			itemsPerPage: 20,
			preDisplayProperties: [],
			displayProperties: [
				{
					field: "description",
					label: "Description",
					type: "string",
					mobile: false,
				},
				{
					field: "queue_no",
					label: "Queue No",
					type: "string",
					columnClass: "col-1",
					mobile: true,
				},
				{
					field: "frequency",
					label: "Frequency",
					type: "string",
					columnClass: "col-1",
					mobile: false,
				},
				{
					field: "start_time",
					label: "Start Time",
					type: "string",
					columnClass: "col-1",
					mobile: false,
				}
				
			],
			displayColumn: [],
		},
	},
	{
		id: 4,
		label: "Job-Queues",
		type: "endpoint",
		endpointId: 3,
		icon: "fa fa-th-list",
		children: [],
		config: {
			adminOnly: false,
			readOnly: true,
			viewType: "EndpointList",
			formComponent: "EndpointForm",
			displayProp: {
				field: "task_id",
				label: "Task",
				type: "reference",
				referenceEndpoint: "tasks",
				referenceField: "name",
			},
			itemsPerPage: 20,
			preDisplayProperties: [],
			displayProperties: [
				{
					field: "process_start_at",
					label: "Job Started",
					type: "datetime",
					dateFormat: "MM-DD-YYYY HH:mm:ss",
					mobile: false,
				},
				{
					field: "process_end_at",
					label: "Job Ended",
					type: "datetime",
					dateFormat: "MM-DD-YYYY HH:mm:ss",
					mobile: false,
				},
				{
					field: "duration",
					label: "Duration",
					type: "string",
					dateFormat: "MM-DD-YYYY HH:mm:ss",
					columnClass: "col-1",
					mobile: false,
				},
				{
					field: "is_processed",
					label: "Processed",
					type: "string",
					columnClass: "col-1",
					mobile: false,
				},
				{
					field: "process_status",
					label: "Status",
					type: "string",
					columnClass: "col-1",
					mobile: true,
				},
				{
					field: "queue_no",
					label: "Queue No",
					type: "string",
					columnClass: "col-1",
					mobile: true,
				},
				// {
				//     field: 'memo',
				//     label: 'Remarks',
				//     type: 'string',
				//     columnClass: 'col-1',
				//     paddingClass: 'pl-5'
				// },
			],
			displayColumn: [],
		},
	},
	{
		id: 14,
		label: "Message-Queues",
		type: "endpoint",
		endpointId: 14,
		icon: "fa fa-th-list",
		children: [],
		config: {
			adminOnly: false,
			readOnly: true,
			viewType: "EndpointList",
			formComponent: "EndpointForm",
			displayProp: {
				field: "task_id",
				label: "Task",
				type: "reference",
				referenceEndpoint: "tasks",
				referenceField: "name",
			},
			itemsPerPage: 20,
			preDisplayProperties: [],
			displayProperties: [
				{
					field: "ref_id",
					label: "Source ID",
					type: "string",
					mobile: true,
					columnClass: 'col-2'
				},
				{
					field: "target_id",
					label: "Target ID",
					type: "string",
					mobile: false,
					columnClass: 'col-2'
				},
				{
					field: "status",
					label: "Status",
					type: "enum",
					enumMap: new Map([
						[-1, "Error"],
						[0, "New Message"],
						...range(1, 9, 1, "Processing"),
						[10, "Referenced "],
						...range(11, 19, 1, "Processing"),
						[20, "Extracted "],
						...range(21, 29, 1, "Processing"),
						[30, "Validated "],
						...range(31, 39, 1, "Processing"),
						[40, "Transformed "],
						...range(41, 49, 1, "Processing"),
						[50, "Stage-loaded "],
						...range(51, 59, 1, "Processing"),
						[60, "Audited "],
						...range(61, 69, 1, "Processing"),
						[70, "Published "],
						...range(71, 79, 1, "Processing"),
						[80, "Responded "],
						...range(81, 89, 1, "Processing"),
						[100, "Completed"],
						...range(101, 899, 1, "Undifined"),
						[900, "Cancelled"],
					]),
					columnClass: "col-1",
					mobile: true,
					//pxClass: 'px-5'
				},
				{
					field: "remarks",
					label: "Remarks",
					type: "json",
					mobile: false,
					columnClass: 'col-2'
				},
				{
					field: "updated_at",
					label: "Last Modified",
					type: "datetime",
					dateFormat: "MM-DD-YYYY HH:mm:ss",
					// dateFormat: 'MM-DD-YYYY',
					columnClass: "col-2",
					pxClass: "pl-5 pr-4",
					mobile: false,
				},
			],
			displayColumn: [],
		},
	},
	// {
	//     id: 5,
	//     label: 'Logs',
	//     type: 'endpoint',
	//     endpointId: 13,
	//     icon: 'fa fa-sticky-note',
	//     children: [],
	//     config: {
	//         viewType: 'EndpointList',
	//         formComponent: 'EndpointForm',
	//         displayProp: {
	//             field:'name',
	//             label:'Name',
	//             type:'string'
	//         },
	//         itemsPerPage: 20,
	//         preDisplayProperties: [],
	//         displayProperties: [
	//             {
	//                 field:'description',
	//                 label: 'Description',
	//                 type: 'string'
	//             }
	//         ],
	//         displayColumn: []
	//     }
	// },
	{
		id: 6,
		label: "Maintenance",
		type: "dropdown",
		endpointId: null,
		icon: "fa fa-sticky-note",
		children: [
			{
				id: 7,
				label: "Providers",
				type: "endpoint",
				endpointId: 4,
				icon: "fa fa-wrench",
				children: [],
				config: {
					adminOnly: false,
					readOnly: false,
					viewType: "EndpointList",
					formComponent: "EndpointForm",
					displayProp: {
						field: "name",
						label: "Name",
						type: "string",
					},
					itemsPerPage: 20,
					preDisplayProperties: [],
					displayProperties: [
						{
							field: "description",
							label: "Description",
							type: "string",
						},
					],
					displayColumn: [],
				},
			},
			{
				id: 8,
				label: "Connections",
				type: "endpoint",
				endpointId: 5,
				icon: "fa fa-th-list",
				children: [],
				config: {
					adminOnly: false,
					readOnly: false,
					viewType: "EndpointList",
					formComponent: "EndpointForm",
					displayProp: {
						field: "name",
						label: "Name",
						type: "string",
					},
					itemsPerPage: 20,
					preDisplayProperties: [],
					displayProperties: [
						{
							field: "description",
							label: "Description",
							type: "string",
						},
					],
					displayColumn: [],
				},
			},
			{
				id: 9,
				label: "Datasources",
				type: "endpoint",
				endpointId: 6,
				icon: "fa fa-sticky-note",
				children: [],
				config: {
					adminOnly: false,
					readOnly: false,
					viewType: "EndpointList",
					formComponent: "EndpointForm",
					displayProp: {
						field: "name",
						label: "Name",
						type: "string",
					},
					itemsPerPage: 20,
					preDisplayProperties: [],
					displayProperties: [
						{
							field: "description",
							label: "Description",
							type: "string",
						},
					],
					displayColumn: [],
				},
			},
			{
				id: 13,
				label: "Frequencies",
				type: "endpoint",
				endpointId: 10,
				icon: "fa fa-sticky-note",
				children: [],
				config: {
					adminOnly: true,
					readOnly: false,
					viewType: "EndpointList",
					formComponent: "EndpointForm",
					displayProp: {
						field: "name",
						label: "Name",
						type: "string",
					},
					itemsPerPage: 20,
					preDisplayProperties: [],
					displayProperties: [
						{
							field: "description",
							label: "Description",
							type: "string",
						},
					],
					displayColumn: [],
				},
			},
			{
				id: 10,
				label: "Users",
				type: "endpoint",
				endpointId: 7,
				icon: "fa fa-sticky-note",
				children: [],
				config: {
					adminOnly: true,
					readOnly: false,
					viewType: "EndpointList",
					formComponent: "EndpointForm",
					displayProp: {
						field: "email",
						label: "Email",
						type: "string",
					},
					itemsPerPage: 20,
					preDisplayProperties: [],
					displayProperties: [
						{
							field: "description",
							label: "Description",
							type: "string",
						},
					],
					displayColumn: [],
				},
			},
			{
				id: 11,
				label: "Roles",
				type: "endpoint",
				endpointId: 8,
				icon: "fa fa-sticky-note",
				children: [],
				config: {
					adminOnly: true,
					readOnly: false,
					viewType: "EndpointList",
					formComponent: "EndpointForm",
					displayProp: {
						field: "name",
						label: "Name",
						type: "string",
					},
					itemsPerPage: 20,
					preDisplayProperties: [],
					displayProperties: [
						{
							field: "description",
							label: "Description",
							type: "string",
						},
					],
					displayColumn: [],
				},
			},
			{
				id: 20,
				label: "Preferences",
				type: "endpoint",
				endpointId: 16,
				icon: "fa fa-sticky-note",
				children: [],
				config: {
					adminOnly: true,
					readOnly: false,
					viewType: "PreferencesForm",
					formComponent: "EndpointForm",
					displayProp: {},
					itemsPerPage: 20,
					preDisplayProperties: [],
					displayProperties: [{}],
					displayColumn: [],
				},
			},
			{
				id: 21,
				label: "Timezones",
				type: "endpoint",
				endpointId: 21,
				icon: "fa fa-sticky-note",
				children: [],
				config: {
					adminOnly: true,
					readOnly: false,
					viewType: "EndpointList",
					formComponent: "EndpointForm",
					displayProp: {
						field: "zone_name",
						label: "Zone Name",
						type: "string",
					},
					itemsPerPage: 20,
					preDisplayProperties: [],
					displayProperties: [
						{
							field: "offset_name",
							label: "Offset Name",
							type: "string",
						},
						{
							field: "offset_value",
							label: "Offset Value",
							type: "string",
						},
						{
							field: "dst",
							label: "DST",
							type: "string",
						},
					],
					displayColumn: [],
				}
			},
			// {
			//     id: 16,
			//     label: 'Releases',
			//     type: 'endpoint',
			//     endpointId: 16,
			//     icon: 'fa fa-sticky-note',
			//     children: [],
			//     config: {
			//         adminOnly: true,
			//         readOnly: false,
			//         viewType: 'EndpointList',
			//         formComponent: 'EndpointForm',
			//         displayProp: {
			//             field: 'version',
			//             label: 'Version',
			//             type: 'string'
			//         },
			//         itemsPerPage: 20,
			//         preDisplayProperties: [],
			//         displayProperties: [
			//             {
			//                 field: 'release_date',
			//                 label: 'Release Date',
			//                 type: 'datetime',
			//                 dateFormat: 'MM-DD-YYYY'
			//             }
			//         ],
			//         displayColumn: []
			//     }
			// },
			// {
			//     id: 17,
			//     label: 'About',
			//     type: 'endpoint',
			//     endpointId: 16,
			//     icon: 'fa fa-sticky-note',
			//     children: [],
			//     config: {
			//         adminOnly: false,
			//         readOnly: false,
			//         viewType: 'ReleaseNoteForm',
			//         formComponent: 'EndpointForm',
			//         displayProp: {
			//             field: 'version',
			//             label: 'Version',
			//             type: 'string'
			//         },
			//         itemsPerPage: 20,
			//         preDisplayProperties: [],
			//         displayProperties: [
			//             {
			//                 field: 'release_date',
			//                 label: 'Release Date',
			//                 type: 'datetime',
			//                 dateFormat: 'MM-DD-YYYY'
			//             }
			//         ],
			//         displayColumn: []
			//     }
			// },
			{
				id: 18,
				label: "Developer-Tools",
				type: "endpoint",
				endpointId: 16,
				icon: "fa fa-sticky-note",
				children: [],
				config: {
					adminOnly: true,
					readOnly: false,
					viewType: "DevelopersToolsForm",
					formComponent: "EndpointForm",
					displayProp: {},
					itemsPerPage: 20,
					preDisplayProperties: [],
					displayProperties: [{}],
					displayColumn: [],
				},
			},
			// {
			//     id: 12,
			//     label: 'ACLs',
			//     type: 'endpoint',
			//     endpointId: 9,
			//     icon: 'fa fa-sticky-note',
			//     children: [],
			//     config: {
			//         readOnly: false,
			//         viewType: 'ACLForm',
			//         formComponent: 'ACLForm',
			//         displayProp: null,
			//         itemsPerPage: 20,
			//         displayProperties: [
			//             {
			//                 field: 'description',
			//                 label: 'Description',
			//                 type: 'string'
			//             }
			//         ],
			//         displayColumns: {
			//             model: {
			//                 type: 'string',
			//                 values: []
			//             },
			//             property: {
			//                 type: 'string',
			//                 values: []
			//             },
			//             accessType: {
			//                 type: 'list',
			//                 values: [
			//                     'WRITE',
			//                     'READ',
			//                     'EXECUTE',
			//                     '*'
			//                 ]
			//             },
			//             permission: {
			//                 type: 'list',
			//                 values: [
			//                     'ALLOW',
			//                     'DENY'
			//                 ]
			//             },
			//             principalType: {
			//                 type: 'list',
			//                 values: [
			//                     'USER',
			//                     'ROLE',
			//                     'APPLICATION'
			//                 ]
			//             },
			//             principalId: {
			//                 type: 'string',
			//                 values: []
			//             }
			//         }
			//     }
			// },
		],
		config: {
			adminOnly: false,
			readOnly: false,
		},
	},
];

export default sidebars;



// WEBPACK FOOTER //
// ./src/config.js